import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export const updateCampaignPositionsState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionIds === undefined) {
        throw new Error('Missing required body: campaignPositionIds');
    }
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.state === undefined) {
        throw new Error('Missing required parameter: state');
    }
    const path = '/api/ws-digital/campaign-positions/change-state';
    const pathInternal = '/api/campaign-positions/change-state';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionIds !== undefined) {
        body = params.campaignPositionIds;
    }
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    if (params.state !== undefined) {
        urlParams.append('state', params.state.toString());
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
updateCampaignPositionsState.paramsOrder = [
    { type: 'body', paramName: 'campaignPositionIds' },
    { type: 'parameters' },
];
export const getCampaignPositionsByCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-digital/campaigns/{campaignId}/campaign-positions'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/campaign-positions'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionsByCampaign.paramsOrder = [{ type: 'parameters' }];
export const createOrUpdateCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-digital/campaigns/{campaignId}/campaign-positions'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/campaign-positions'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createOrUpdateCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const createOrUpdateSingleCampaignPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-digital/campaigns/{campaignId}/campaign-positions/single'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/campaign-positions/single'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createOrUpdateSingleCampaignPosition.paramsOrder = [
    { type: 'body', paramName: 'form' },
    { type: 'parameters' },
];
export const createCampaignPositionsForImport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-digital/campaign-positions/import';
    const pathInternal = '/api/campaign-positions/import';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionForms !== undefined) {
        body = params.campaignPositionForms;
    }
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
createCampaignPositionsForImport.paramsOrder = [
    { type: 'body', paramName: 'campaignPositionForms' },
    { type: 'parameters' },
];
export const updateDiscounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.discountForm === undefined) {
        throw new Error('Missing required body: discountForm');
    }
    const path = '/api/ws-digital/campaign-positions/update-discounts';
    const pathInternal = '/api/campaign-positions/update-discounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    if (params.discountForm !== undefined) {
        body = params.discountForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateDiscounts.paramsOrder = [{ type: 'body', paramName: 'discountForm' }, { type: 'parameters' }];
export const downloadDailyDeliveryReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-digital/campaigns/{campaignId}/daily-delivery/download'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/daily-delivery/download'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadDailyDeliveryReport.paramsOrder = [{ type: 'parameters' }];
export const downloadDailyDeliveryReportIncludingRevenueGross1 = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-digital/campaigns/{campaignId}/daily-delivery-including-revenue-gross1/download'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/daily-delivery-including-revenue-gross1/download'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadDailyDeliveryReportIncludingRevenueGross1.paramsOrder = [{ type: 'parameters' }];
export const downloadWebsiteDeliveryReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-digital/campaigns/{campaignId}/website-delivery/download'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/website-delivery/download'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadWebsiteDeliveryReport.paramsOrder = [{ type: 'parameters' }];
export const downloadPlacementDeliveryReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-digital/campaigns/{campaignId}/placement-delivery/download'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/placement-delivery/download'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadPlacementDeliveryReport.paramsOrder = [{ type: 'parameters' }];
export const downloadCreativeDeliveryReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-digital/campaigns/{campaignId}/cretive-delivery/download'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/cretive-delivery/download'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadCreativeDeliveryReport.paramsOrder = [{ type: 'parameters' }];
export const downloadWebsiteDailyDeliveryReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-digital/campaigns/{campaignId}/website-daily-delivery/download'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/website-daily-delivery/download'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadWebsiteDailyDeliveryReport.paramsOrder = [{ type: 'parameters' }];
export const downloadDeviceDeliveryReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-digital/campaigns/{campaignId}/device-delivery/download'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/device-delivery/download'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadDeviceDeliveryReport.paramsOrder = [{ type: 'parameters' }];
export const createOrUpdateSspCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.sspCampaignPositions === undefined) {
        throw new Error('Missing required body: sspCampaignPositions');
    }
    const path = '/api/ws-digital/ssp/campaign-positions';
    const pathInternal = '/api/ssp/campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.sspCampaignPositions !== undefined) {
        body = params.sspCampaignPositions;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createOrUpdateSspCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'sspCampaignPositions' }];
export const deleteSspCampaignPositionByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionIdsToDelete === undefined) {
        throw new Error('Missing required body: campaignPositionIdsToDelete');
    }
    const path = '/api/ws-digital/ssp/campaign-positions';
    const pathInternal = '/api/ssp/campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionIdsToDelete !== undefined) {
        body = params.campaignPositionIdsToDelete;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteSspCampaignPositionByIds.paramsOrder = [{ type: 'body', paramName: 'campaignPositionIdsToDelete' }];
export const createOrUpdateSspDeliveryData = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.dto === undefined) {
        throw new Error('Missing required body: dto');
    }
    const path = '/api/ws-digital/ssp/delivery-data';
    const pathInternal = '/api/ssp/delivery-data';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.dto !== undefined) {
        body = params.dto;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createOrUpdateSspDeliveryData.paramsOrder = [{ type: 'body', paramName: 'dto' }];
export const deleteSspDeliveryDataByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.deliveryDataIdsToDelete === undefined) {
        throw new Error('Missing required body: deliveryDataIdsToDelete');
    }
    const path = '/api/ws-digital/ssp/delivery-data';
    const pathInternal = '/api/ssp/delivery-data';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.deliveryDataIdsToDelete !== undefined) {
        body = params.deliveryDataIdsToDelete;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteSspDeliveryDataByIds.paramsOrder = [{ type: 'body', paramName: 'deliveryDataIdsToDelete' }];
export const getManualDeliveryData = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-digital/campaign-position/{campaignPositionId}/delivery-data'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/campaign-position/{campaignPositionId}/delivery-data'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getManualDeliveryData.paramsOrder = [{ type: 'parameters' }];
export const createManualDeliveryData = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.deliveryData === undefined) {
        throw new Error('Missing required body: deliveryData');
    }
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-digital/campaign-position/{campaignPositionId}/delivery-data'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/campaign-position/{campaignPositionId}/delivery-data'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.deliveryData !== undefined) {
        body = params.deliveryData;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createManualDeliveryData.paramsOrder = [{ type: 'body', paramName: 'deliveryData' }, { type: 'parameters' }];
export const updateManualDeliveryData = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.deliveryData === undefined) {
        throw new Error('Missing required body: deliveryData');
    }
    if (params.manualDeliveryDataId === undefined) {
        throw new Error('Missing required parameter: manualDeliveryDataId');
    }
    const path = '/api/ws-digital/campaign-position/delivery-data/{manualDeliveryDataId}'.replace('{manualDeliveryDataId}', params.manualDeliveryDataId?.toString());
    const pathInternal = '/api/campaign-position/delivery-data/{manualDeliveryDataId}'.replace('{manualDeliveryDataId}', params.manualDeliveryDataId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.deliveryData !== undefined) {
        body = params.deliveryData;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateManualDeliveryData.paramsOrder = [{ type: 'body', paramName: 'deliveryData' }, { type: 'parameters' }];
export const deleteManualDeliveryData = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.manualDeliveryDataId === undefined) {
        throw new Error('Missing required parameter: manualDeliveryDataId');
    }
    const path = '/api/ws-digital/campaign-position/delivery-data/{manualDeliveryDataId}'.replace('{manualDeliveryDataId}', params.manualDeliveryDataId?.toString());
    const pathInternal = '/api/campaign-position/delivery-data/{manualDeliveryDataId}'.replace('{manualDeliveryDataId}', params.manualDeliveryDataId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteManualDeliveryData.paramsOrder = [{ type: 'parameters' }];
export const getWebsitesForManualDeliveryData = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-digital/campaign-position/{campaignPositionId}/delivery-data/websites'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/campaign-position/{campaignPositionId}/delivery-data/websites'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getWebsitesForManualDeliveryData.paramsOrder = [{ type: 'parameters' }];
export const areDeliveryDataLockedByCampaignId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-digital/campaign-position/delivery-data/is-locked';
    const pathInternal = '/api/campaign-position/delivery-data/is-locked';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
areDeliveryDataLockedByCampaignId.paramsOrder = [{ type: 'parameters' }];
export const getAdServerMetaData = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-digital/campaign-positions/ad-server-meta-data/{campaignPositionId}'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/campaign-positions/ad-server-meta-data/{campaignPositionId}'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdServerMetaData.paramsOrder = [{ type: 'parameters' }];
export const replaceAdServerMetaData = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adServerMetaData === undefined) {
        throw new Error('Missing required body: adServerMetaData');
    }
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-digital/campaign-positions/ad-server-meta-data/{campaignPositionId}'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/campaign-positions/ad-server-meta-data/{campaignPositionId}'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adServerMetaData !== undefined) {
        body = params.adServerMetaData;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
replaceAdServerMetaData.paramsOrder = [
    { type: 'body', paramName: 'adServerMetaData' },
    { type: 'parameters' },
];
export const clonePosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-digital/campaign-positions/{campaignPositionId}/clone'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/campaign-positions/{campaignPositionId}/clone'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
clonePosition.paramsOrder = [{ type: 'parameters' }];
export const cloneCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.originalCampaignId === undefined) {
        throw new Error('Missing required parameter: originalCampaignId');
    }
    const path = '/api/ws-digital/campaign-positions/clone-by-campaign';
    const pathInternal = '/api/campaign-positions/clone-by-campaign';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    if (params.originalCampaignId !== undefined) {
        urlParams.append('originalCampaignId', params.originalCampaignId.toString());
    }
    if (params.shouldFetchActualCommission !== undefined) {
        urlParams.append('shouldFetchActualCommission', params.shouldFetchActualCommission.toString());
    }
    if (params.manualStartDate !== undefined) {
        urlParams.append('manualStartDate', params.manualStartDate.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cloneCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const findInactiveProductPositionsOnClone = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-digital/campaigns/{campaignId}/campaign-positions/inactive-product'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/campaign-positions/inactive-product'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
findInactiveProductPositionsOnClone.paramsOrder = [{ type: 'parameters' }];
export const getPreviewLinksByCampaignPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-digital/campaign-position/{campaignPositionId}/preview-links'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/campaign-position/{campaignPositionId}/preview-links'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPreviewLinksByCampaignPosition.paramsOrder = [{ type: 'parameters' }];
export const checkCanCampaignPositionBeDeletedWithForm = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPosition === undefined) {
        throw new Error('Missing required body: campaignPosition');
    }
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-digital/campaigns/campaign-positions/{campaignPositionId}/check-delete'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/campaigns/campaign-positions/{campaignPositionId}/check-delete'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPosition !== undefined) {
        body = params.campaignPosition;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
checkCanCampaignPositionBeDeletedWithForm.paramsOrder = [
    { type: 'body', paramName: 'campaignPosition' },
    { type: 'parameters' },
];
export const findCampaignPositionById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-digital/campaign-positions/{campaignPositionId}'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/campaign-positions/{campaignPositionId}'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
findCampaignPositionById.paramsOrder = [{ type: 'parameters' }];
export const deleteCampaignPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-digital/campaign-positions/{campaignPositionId}'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/campaign-positions/{campaignPositionId}'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteCampaignPosition.paramsOrder = [{ type: 'parameters' }];
export const extractCampaignPositionsToNewCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionIds === undefined) {
        throw new Error('Missing required body: campaignPositionIds');
    }
    const path = '/api/ws-digital/campaign-positions/extract-new-campaign';
    const pathInternal = '/api/campaign-positions/extract-new-campaign';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionIds !== undefined) {
        body = params.campaignPositionIds;
    }
    const headers = {};
    headers['Accept'] = 'text/plain';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
extractCampaignPositionsToNewCampaign.paramsOrder = [{ type: 'body', paramName: 'campaignPositionIds' }];
export const getCampaignPositionsByCreativeId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    const path = '/api/ws-digital/creatives/{creativeId}/campaign-positions'.replace('{creativeId}', params.creativeId?.toString());
    const pathInternal = '/api/creatives/{creativeId}/campaign-positions'.replace('{creativeId}', params.creativeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionsByCreativeId.paramsOrder = [{ type: 'parameters' }];
export const getRemovedCreativeIdsByCampaignPositionId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-digital/campaign-positions/{campaignPositionId}/removed-creatives'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/campaign-positions/{campaignPositionId}/removed-creatives'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getRemovedCreativeIdsByCampaignPositionId.paramsOrder = [{ type: 'parameters' }];
export const unlinkCreativeFromCampaignPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    const path = '/api/ws-digital/campaign-positions/{campaignPositionId}/unlink-creative'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/campaign-positions/{campaignPositionId}/unlink-creative'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creativeId !== undefined) {
        urlParams.append('creativeId', params.creativeId.toString());
    }
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
unlinkCreativeFromCampaignPosition.paramsOrder = [{ type: 'parameters' }];
export const unlinkCreativeFromAllPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    const path = '/api/ws-digital/creatives/{creativeId}/unlink-all-positions'.replace('{creativeId}', params.creativeId?.toString());
    const pathInternal = '/api/creatives/{creativeId}/unlink-all-positions'.replace('{creativeId}', params.creativeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
unlinkCreativeFromAllPositions.paramsOrder = [{ type: 'parameters' }];
export const updateCreativeCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionIds === undefined) {
        throw new Error('Missing required body: campaignPositionIds');
    }
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    const path = '/api/ws-digital/creatives/{creativeId}/update-campaign-positions'.replace('{creativeId}', params.creativeId?.toString());
    const pathInternal = '/api/creatives/{creativeId}/update-campaign-positions'.replace('{creativeId}', params.creativeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionIds !== undefined) {
        body = params.campaignPositionIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
updateCreativeCampaignPositions.paramsOrder = [
    { type: 'body', paramName: 'campaignPositionIds' },
    { type: 'parameters' },
];
export const bulkUpdateCreativeCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.creativesPositions === undefined) {
        throw new Error('Missing required body: creativesPositions');
    }
    const path = '/api/ws-digital/creatives/bulk-update-campaign-positions';
    const pathInternal = '/api/creatives/bulk-update-campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creativesPositions !== undefined) {
        body = params.creativesPositions;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
bulkUpdateCreativeCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'creativesPositions' }];
export const getPaginatedPayoutConfigs = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/payout-configs';
    const pathInternal = '/api/payout-configs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPaginatedPayoutConfigs.paramsOrder = [{ type: 'parameters' }];
export const createPayoutConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.payoutConfigForm === undefined) {
        throw new Error('Missing required body: payoutConfigForm');
    }
    const path = '/api/ws-digital/payout-configs';
    const pathInternal = '/api/payout-configs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.payoutConfigForm !== undefined) {
        body = params.payoutConfigForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createPayoutConfig.paramsOrder = [{ type: 'body', paramName: 'payoutConfigForm' }];
export const getSharedPaginatedPayoutConfigs = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/payout-configs/shared';
    const pathInternal = '/api/payout-configs/shared';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSharedPaginatedPayoutConfigs.paramsOrder = [{ type: 'parameters' }];
export const getPayoutConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/payout-configs/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/payout-configs/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPayoutConfig.paramsOrder = [{ type: 'parameters' }];
export const updatePayoutConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.payoutConfigForm === undefined) {
        throw new Error('Missing required body: payoutConfigForm');
    }
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/payout-configs/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/payout-configs/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.payoutConfigForm !== undefined) {
        body = params.payoutConfigForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updatePayoutConfig.paramsOrder = [{ type: 'body', paramName: 'payoutConfigForm' }, { type: 'parameters' }];
export const deletePayoutConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/payout-configs/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/payout-configs/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deletePayoutConfig.paramsOrder = [{ type: 'parameters' }];
export const getPayoutWebsitesForPayoutConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/payout-configs/{id}/payout-websites'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/payout-configs/{id}/payout-websites'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPayoutWebsitesForPayoutConfig.paramsOrder = [{ type: 'parameters' }];
export const getPaginatedPayoutWebsites = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/payout-websites';
    const pathInternal = '/api/payout-websites';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.includeInactiveWebsites !== undefined) {
        urlParams.append('includeInactiveWebsites', params.includeInactiveWebsites.toString());
    }
    if (params.payoutConfigId !== undefined) {
        urlParams.append('payoutConfigId', params.payoutConfigId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPaginatedPayoutWebsites.paramsOrder = [{ type: 'parameters' }];
export const createPayoutWebsite = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    if (params.payoutConfigForm === undefined) {
        throw new Error('Missing required body: payoutConfigForm');
    }
    const path = '/api/ws-digital/payout-websites';
    const pathInternal = '/api/payout-websites';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.websiteId !== undefined) {
        urlParams.append('websiteId', params.websiteId.toString());
    }
    if (params.payoutConfigForm !== undefined) {
        body = params.payoutConfigForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createPayoutWebsite.paramsOrder = [{ type: 'body', paramName: 'payoutConfigForm' }, { type: 'parameters' }];
export const getSharedPaginatedPayoutWebsites = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/payout-websites/shared';
    const pathInternal = '/api/payout-websites/shared';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSharedPaginatedPayoutWebsites.paramsOrder = [{ type: 'parameters' }];
export const getPayoutWebsite = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/payout-websites/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/payout-websites/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPayoutWebsite.paramsOrder = [{ type: 'parameters' }];
export const updatePayoutWebsite = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.payoutWebsiteForm === undefined) {
        throw new Error('Missing required body: payoutWebsiteForm');
    }
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/payout-websites/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/payout-websites/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.payoutWebsiteForm !== undefined) {
        body = params.payoutWebsiteForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updatePayoutWebsite.paramsOrder = [{ type: 'body', paramName: 'payoutWebsiteForm' }, { type: 'parameters' }];
export const updatePayoutWebsiteState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-digital/payout-websites/{id}/update-state'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/payout-websites/{id}/update-state'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.active !== undefined) {
        urlParams.append('active', params.active.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updatePayoutWebsiteState.paramsOrder = [{ type: 'parameters' }];
export const getPayoutWebsiteAssignableWebsites = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/payout-websites/assignable-websites';
    const pathInternal = '/api/payout-websites/assignable-websites';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.includeInactive !== undefined) {
        urlParams.append('includeInactive', params.includeInactive.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPayoutWebsiteAssignableWebsites.paramsOrder = [{ type: 'parameters' }];
export const getApprovedPayouts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/payouts/{websiteId}/approved'.replace('{websiteId}', params.websiteId?.toString());
    const pathInternal = '/api/payouts/{websiteId}/approved'.replace('{websiteId}', params.websiteId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.dateFrom !== undefined) {
        urlParams.append('dateFrom', params.dateFrom.toString());
    }
    if (params.dateTo !== undefined) {
        urlParams.append('dateTo', params.dateTo.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getApprovedPayouts.paramsOrder = [{ type: 'parameters' }];
export const getMonthlyApprovedPayoutsByPayoutWebsiteIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.payoutWebsiteIds === undefined) {
        throw new Error('Missing required body: payoutWebsiteIds');
    }
    const path = '/api/ws-digital/payouts/approved';
    const pathInternal = '/api/payouts/approved';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.payoutWebsiteIds !== undefined) {
        body = params.payoutWebsiteIds;
    }
    if (params.dateFrom !== undefined) {
        urlParams.append('dateFrom', params.dateFrom.toString());
    }
    if (params.dateTo !== undefined) {
        urlParams.append('dateTo', params.dateTo.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getMonthlyApprovedPayoutsByPayoutWebsiteIds.paramsOrder = [
    { type: 'body', paramName: 'payoutWebsiteIds' },
    { type: 'parameters' },
];
export const downloadCombinedPayoutReportByPayoutIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-digital/payouts/download-combined-report-by-payout-ids';
    const pathInternal = '/api/payouts/download-combined-report-by-payout-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadCombinedPayoutReportByPayoutIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
export const approveCombinedPayouts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-digital/payouts/approve-combined';
    const pathInternal = '/api/payouts/approve-combined';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
approveCombinedPayouts.paramsOrder = [{ type: 'body', paramName: 'ids' }];
export const findLatestPayoutMonth = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-digital/payouts/month/latest';
    const pathInternal = '/api/payouts/month/latest';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
findLatestPayoutMonth.paramsOrder = [{ type: 'parameters' }];
export const hasApprovedPayoutsByCampaignId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-digital/payouts/has-approved/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/payouts/has-approved/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
hasApprovedPayoutsByCampaignId.paramsOrder = [{ type: 'parameters' }];
export const hasApprovedPayoutsByMonthAndCompanyId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.date === undefined) {
        throw new Error('Missing required parameter: date');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-digital/payouts/{date}/has-approved/by-company-id/{companyId}'
        .replace('{date}', params.date?.toString())
        .replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/payouts/{date}/has-approved/by-company-id/{companyId}'
        .replace('{date}', params.date?.toString())
        .replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
hasApprovedPayoutsByMonthAndCompanyId.paramsOrder = [{ type: 'parameters' }];
export const getPayoutsByMonth = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.date === undefined) {
        throw new Error('Missing required parameter: date');
    }
    const path = '/api/ws-digital/payouts/{date}'.replace('{date}', params.date?.toString());
    const pathInternal = '/api/payouts/{date}'.replace('{date}', params.date?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.payoutConfigId !== undefined) {
        urlParams.append('payoutConfigId', params.payoutConfigId.toString());
    }
    if (params.stateFilter !== undefined) {
        urlParams.append('stateFilter', params.stateFilter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPayoutsByMonth.paramsOrder = [{ type: 'parameters' }];
export const getTotalPayoutsPerProduct = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.date === undefined) {
        throw new Error('Missing required parameter: date');
    }
    const path = '/api/ws-digital/payouts/{date}/statistics/payouts-per-product'.replace('{date}', params.date?.toString());
    const pathInternal = '/api/payouts/{date}/statistics/payouts-per-product'.replace('{date}', params.date?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTotalPayoutsPerProduct.paramsOrder = [{ type: 'parameters' }];
export const getTotalPayoutsPerProductRevenue = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.date === undefined) {
        throw new Error('Missing required parameter: date');
    }
    const path = '/api/ws-digital/payouts/{date}/statistics/total-revenue'.replace('{date}', params.date?.toString());
    const pathInternal = '/api/payouts/{date}/statistics/total-revenue'.replace('{date}', params.date?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTotalPayoutsPerProductRevenue.paramsOrder = [{ type: 'parameters' }];
export const getPayoutModificationsByMonth = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.date === undefined) {
        throw new Error('Missing required parameter: date');
    }
    const path = '/api/ws-digital/payouts/{date}/modifications'.replace('{date}', params.date?.toString());
    const pathInternal = '/api/payouts/{date}/modifications'.replace('{date}', params.date?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPayoutModificationsByMonth.paramsOrder = [{ type: 'parameters' }];
export const addModificationToPayout = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.date === undefined) {
        throw new Error('Missing required parameter: date');
    }
    if (params.modification === undefined) {
        throw new Error('Missing required body: modification');
    }
    const path = '/api/ws-digital/payouts/{date}/modifications'.replace('{date}', params.date?.toString());
    const pathInternal = '/api/payouts/{date}/modifications'.replace('{date}', params.date?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.modification !== undefined) {
        body = params.modification;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addModificationToPayout.paramsOrder = [{ type: 'body', paramName: 'modification' }, { type: 'parameters' }];
export const removeModificationFromPayout = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.modificationId === undefined) {
        throw new Error('Missing required parameter: modificationId');
    }
    const path = '/api/ws-digital/payouts/modifications/{modificationId}/delete'.replace('{modificationId}', params.modificationId?.toString());
    const pathInternal = '/api/payouts/modifications/{modificationId}/delete'.replace('{modificationId}', params.modificationId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
removeModificationFromPayout.paramsOrder = [{ type: 'parameters' }];
export const downloadAllReports = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.date === undefined) {
        throw new Error('Missing required parameter: date');
    }
    const path = '/api/ws-digital/payouts/{date}/download-all-reports'.replace('{date}', params.date?.toString());
    const pathInternal = '/api/payouts/{date}/download-all-reports'.replace('{date}', params.date?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadAllReports.paramsOrder = [{ type: 'parameters' }];
export const getPayoutRawDataPerPublisher = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.date === undefined) {
        throw new Error('Missing required parameter: date');
    }
    const path = '/api/ws-digital/payouts/{date}/download-payout-raw-data-per-publisher'.replace('{date}', params.date?.toString());
    const pathInternal = '/api/payouts/{date}/download-payout-raw-data-per-publisher'.replace('{date}', params.date?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPayoutRawDataPerPublisher.paramsOrder = [{ type: 'parameters' }];
export const getPayoutRawDataPerCampaignPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.date === undefined) {
        throw new Error('Missing required parameter: date');
    }
    const path = '/api/ws-digital/payouts/{date}/download-payout-raw-data-per-campaign-position'.replace('{date}', params.date?.toString());
    const pathInternal = '/api/payouts/{date}/download-payout-raw-data-per-campaign-position'.replace('{date}', params.date?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPayoutRawDataPerCampaignPosition.paramsOrder = [{ type: 'parameters' }];
export const getPayoutCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.monthDate === undefined) {
        throw new Error('Missing required parameter: monthDate');
    }
    if (params.currency === undefined) {
        throw new Error('Missing required parameter: currency');
    }
    const path = '/api/ws-digital/payouts/{monthDate}/campaign-positions'.replace('{monthDate}', params.monthDate?.toString());
    const pathInternal = '/api/payouts/{monthDate}/campaign-positions'.replace('{monthDate}', params.monthDate?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.currency !== undefined) {
        urlParams.append('currency', params.currency.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPayoutCampaignPositions.paramsOrder = [{ type: 'parameters' }];
export const downloadCombinedPayoutReportByPayoutWebsiteIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.date === undefined) {
        throw new Error('Missing required parameter: date');
    }
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-digital/payouts/{date}/download-combined-report-by-payout-website-ids'.replace('{date}', params.date?.toString());
    const pathInternal = '/api/payouts/{date}/download-combined-report-by-payout-website-ids'.replace('{date}', params.date?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadCombinedPayoutReportByPayoutWebsiteIds.paramsOrder = [
    { type: 'body', paramName: 'ids' },
    { type: 'parameters' },
];
export const getAllNonApprovedWebsitesByMonth = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.date === undefined) {
        throw new Error('Missing required parameter: date');
    }
    const path = '/api/ws-digital/payouts/{date}/websites'.replace('{date}', params.date?.toString());
    const pathInternal = '/api/payouts/{date}/websites'.replace('{date}', params.date?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllNonApprovedWebsitesByMonth.paramsOrder = [{ type: 'parameters' }];
export const isPayoutMonthClosed = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.date === undefined) {
        throw new Error('Missing required parameter: date');
    }
    const path = '/api/ws-digital/payouts/{date}/is-closed'.replace('{date}', params.date?.toString());
    const pathInternal = '/api/payouts/{date}/is-closed'.replace('{date}', params.date?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
isPayoutMonthClosed.paramsOrder = [{ type: 'parameters' }];
export const createReportIfNotExists = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/payout/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/payout/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createReportIfNotExists.paramsOrder = [{ type: 'parameters' }];
export const generateSingleReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/payout/{id}/generate-single-report'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/payout/{id}/generate-single-report'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
generateSingleReport.paramsOrder = [{ type: 'parameters' }];
export const regenerateSingleReportPdf = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/payout/{id}/regenerate-single-report-pdf'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/payout/{id}/regenerate-single-report-pdf'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
regenerateSingleReportPdf.paramsOrder = [{ type: 'parameters' }];
export const downloadPayoutDetailReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/payout/{id}/download-detail-report'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/payout/{id}/download-detail-report'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadPayoutDetailReport.paramsOrder = [{ type: 'parameters' }];
export const generatePayoutDetailReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/payout/{id}/generate-detail-report'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/payout/{id}/generate-detail-report'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
generatePayoutDetailReport.paramsOrder = [{ type: 'parameters' }];
export const downloadPayoutReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/payout/{id}/download-report'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/payout/{id}/download-report'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: {
            200: 'json',
            204: 'json',
        },
        requestType: 'json',
    });
};
downloadPayoutReport.paramsOrder = [{ type: 'parameters' }];
export const approvePayout = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/payout/{id}/approve'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/payout/{id}/approve'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
approvePayout.paramsOrder = [{ type: 'parameters' }];
export const disapprovePayout = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/payout/{id}/disapprove'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/payout/{id}/disapprove'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
disapprovePayout.paramsOrder = [{ type: 'parameters' }];
export const updateWebsite = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    if (params.website === undefined) {
        throw new Error('Missing required body: website');
    }
    const path = '/api/ws-digital/website/{websiteId}'.replace('{websiteId}', params.websiteId?.toString());
    const pathInternal = '/api/website/{websiteId}'.replace('{websiteId}', params.websiteId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.website !== undefined) {
        body = params.website;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateWebsite.paramsOrder = [{ type: 'body', paramName: 'website' }, { type: 'parameters' }];
export const getWebsiteById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/website/{websiteId}'.replace('{websiteId}', params.websiteId?.toString());
    const pathInternal = '/api/website/{websiteId}'.replace('{websiteId}', params.websiteId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getWebsiteById.paramsOrder = [{ type: 'parameters' }];
export const getWebsiteSellerIdById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/website/{websiteId}/seller-id'.replace('{websiteId}', params.websiteId?.toString());
    const pathInternal = '/api/website/{websiteId}/seller-id'.replace('{websiteId}', params.websiteId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'text/plain';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
getWebsiteSellerIdById.paramsOrder = [{ type: 'parameters' }];
export const getWebsiteChildPublisherNetworkCodeById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/website/{websiteId}/child-publisher-network-code'.replace('{websiteId}', params.websiteId?.toString());
    const pathInternal = '/api/website/{websiteId}/child-publisher-network-code'.replace('{websiteId}', params.websiteId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getWebsiteChildPublisherNetworkCodeById.paramsOrder = [{ type: 'parameters' }];
export const getWebsiteAdMediums = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/website/{websiteId}/ad-mediums'.replace('{websiteId}', params.websiteId?.toString());
    const pathInternal = '/api/website/{websiteId}/ad-mediums'.replace('{websiteId}', params.websiteId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getWebsiteAdMediums.paramsOrder = [{ type: 'parameters' }];
export const getWebsites = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/websites';
    const pathInternal = '/api/websites';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.nameFilter !== undefined) {
        urlParams.append('nameFilter', params.nameFilter.toString());
    }
    if (params.includeInactive !== undefined) {
        urlParams.append('includeInactive', params.includeInactive.toString());
    }
    if (params.labelId !== undefined) {
        urlParams.append('labelId', params.labelId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getWebsites.paramsOrder = [{ type: 'parameters' }];
export const createWebsite = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.website === undefined) {
        throw new Error('Missing required body: website');
    }
    const path = '/api/ws-digital/websites';
    const pathInternal = '/api/websites';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.website !== undefined) {
        body = params.website;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createWebsite.paramsOrder = [{ type: 'body', paramName: 'website' }];
export const getFilteredWebsites = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.filter === undefined) {
        throw new Error('Missing required body: filter');
    }
    const path = '/api/ws-digital/websites/filtered';
    const pathInternal = '/api/websites/filtered';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        body = params.filter;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getFilteredWebsites.paramsOrder = [{ type: 'body', paramName: 'filter' }];
export const getWebsitesContainingDomainName = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/websites-with-domain-name';
    const pathInternal = '/api/websites-with-domain-name';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.active !== undefined) {
        urlParams.append('active', params.active.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getWebsitesContainingDomainName.paramsOrder = [{ type: 'parameters' }];
export const getWebsiteIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/own-website-ids';
    const pathInternal = '/api/own-website-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getWebsiteIds.paramsOrder = [];
export const findAllAdminWebsites = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/admin/websites';
    const pathInternal = '/api/admin/websites';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.nameFilter !== undefined) {
        urlParams.append('nameFilter', params.nameFilter.toString());
    }
    if (params.companyIdFilter !== undefined) {
        urlParams.append('companyIdFilter', params.companyIdFilter.toString());
    }
    if (params.includeInactive !== undefined) {
        urlParams.append('includeInactive', params.includeInactive.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
findAllAdminWebsites.paramsOrder = [{ type: 'parameters' }];
export const findAdminWebsitesPermittedCompanies = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/admin/websites/permitted-companies';
    const pathInternal = '/api/admin/websites/permitted-companies';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
findAdminWebsitesPermittedCompanies.paramsOrder = [];
export const updateAdminWebsite = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-digital/admin/websites/{websiteId}'.replace('{websiteId}', params.websiteId?.toString());
    const pathInternal = '/api/admin/websites/{websiteId}'.replace('{websiteId}', params.websiteId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
updateAdminWebsite.paramsOrder = [{ type: 'parameters' }];
export const getPublisherBrands = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/publisher/brands';
    const pathInternal = '/api/publisher/brands';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPublisherBrands.paramsOrder = [{ type: 'parameters' }];
export const downloadPublisherBrands = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/publisher/brands/download';
    const pathInternal = '/api/publisher/brands/download';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadPublisherBrands.paramsOrder = [];
export const getBrandPublishers = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/brand/publishers';
    const pathInternal = '/api/brand/publishers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBrandPublishers.paramsOrder = [{ type: 'parameters' }];
export const downloadBrandPublishers = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/brands/publisher/download';
    const pathInternal = '/api/brands/publisher/download';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadBrandPublishers.paramsOrder = [{ type: 'parameters' }];
export const getAdSpecById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/adspecs/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/adspecs/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdSpecById.paramsOrder = [{ type: 'parameters' }];
export const updateAdSpec = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adSpec === undefined) {
        throw new Error('Missing required body: adSpec');
    }
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/adspecs/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/adspecs/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adSpec !== undefined) {
        body = params.adSpec;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdSpec.paramsOrder = [{ type: 'body', paramName: 'adSpec' }, { type: 'parameters' }];
export const checkForAdSpecCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/adspecs/{id}/check-for-positions'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/adspecs/{id}/check-for-positions'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
checkForAdSpecCampaignPositions.paramsOrder = [{ type: 'parameters' }];
export const getAdSpecsByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adSpecIds === undefined) {
        throw new Error('Missing required body: adSpecIds');
    }
    const path = '/api/ws-digital/adspecs/ids';
    const pathInternal = '/api/adspecs/ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adSpecIds !== undefined) {
        body = params.adSpecIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdSpecsByIds.paramsOrder = [{ type: 'body', paramName: 'adSpecIds' }];
export const getCampaignPositionsCountByAdSpecId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/adspecs/{id}/campaign-positions/count'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/adspecs/{id}/campaign-positions/count'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionsCountByAdSpecId.paramsOrder = [{ type: 'parameters' }];
export const getAdServerIdsByCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/campaigns/ad-server-ids';
    const pathInternal = '/api/campaigns/ad-server-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdServerIdsByCampaign.paramsOrder = [{ type: 'parameters' }];
export const getCampaignsPositionsByAdServerType = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adServerType === undefined) {
        throw new Error('Missing required parameter: adServerType');
    }
    const path = '/api/ws-digital/campaigns/{adServerType}/positions'.replace('{adServerType}', params.adServerType?.toString());
    const pathInternal = '/api/campaigns/{adServerType}/positions'.replace('{adServerType}', params.adServerType?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignsPositionsByAdServerType.paramsOrder = [{ type: 'parameters' }];
export const getAdServerIdsByCampaignPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-digital/campaign-positions/ad-server-ids';
    const pathInternal = '/api/campaign-positions/ad-server-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionId !== undefined) {
        urlParams.append('campaignPositionId', params.campaignPositionId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdServerIdsByCampaignPosition.paramsOrder = [{ type: 'parameters' }];
export const getAdServerMetaDataByCampaignId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-digital/ad-server/metadata-by-campaign/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/ad-server/metadata-by-campaign/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdServerMetaDataByCampaignId.paramsOrder = [{ type: 'parameters' }];
export const activateAdServerStateForCampaignPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-digital/ad-server/activate/{campaignPositionId}'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/ad-server/activate/{campaignPositionId}'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
activateAdServerStateForCampaignPosition.paramsOrder = [{ type: 'parameters' }];
export const deactivateAdServerStateForCampaignPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-digital/ad-server/deactivate/{campaignPositionId}'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/ad-server/deactivate/{campaignPositionId}'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
deactivateAdServerStateForCampaignPosition.paramsOrder = [{ type: 'parameters' }];
export const getBatchWebsites = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-digital/batch/websites';
    const pathInternal = '/api/batch/websites';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchWebsites.paramsOrder = [{ type: 'parameters' }];
export const getReportingCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-digital/reporting/campaign-positions';
    const pathInternal = '/api/reporting/campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingCampaignPositions.paramsOrder = [{ type: 'parameters' }];
export const getReportingWebsites = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.maxImportedId === undefined) {
        throw new Error('Missing required parameter: maxImportedId');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-digital/reporting/websites';
    const pathInternal = '/api/reporting/websites';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.maxImportedId !== undefined) {
        urlParams.append('maxImportedId', params.maxImportedId.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingWebsites.paramsOrder = [{ type: 'parameters' }];
export const getReportingPayouts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-digital/reporting/payouts';
    const pathInternal = '/api/reporting/payouts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingPayouts.paramsOrder = [{ type: 'parameters' }];
export const getReportingAdPrices = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-digital/reporting/ad-prices';
    const pathInternal = '/api/reporting/ad-prices';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingAdPrices.paramsOrder = [{ type: 'parameters' }];
export const getBookingAdSpecsWithCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.filter === undefined) {
        throw new Error('Missing required body: filter');
    }
    const path = '/api/ws-digital/booking/ad-specs-with-campaign-positions';
    const pathInternal = '/api/booking/ad-specs-with-campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        body = params.filter;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBookingAdSpecsWithCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'filter' }];
export const getBatchCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.period === undefined) {
        throw new Error('Missing required parameter: period');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-digital/batch/campaign-positions';
    const pathInternal = '/api/batch/campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchCampaignPositions.paramsOrder = [{ type: 'parameters' }];
export const getBatchCampaignPositionsByCampaignsNoConsulting = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.period === undefined) {
        throw new Error('Missing required parameter: period');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-digital/batch/campaign-positions/by-campaigns/no-consulting';
    const pathInternal = '/api/batch/campaign-positions/by-campaigns/no-consulting';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchCampaignPositionsByCampaignsNoConsulting.paramsOrder = [{ type: 'parameters' }];
export const getBatchAdMedium = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.period === undefined) {
        throw new Error('Missing required parameter: period');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-digital/batch/ad-medium';
    const pathInternal = '/api/batch/ad-medium';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchAdMedium.paramsOrder = [{ type: 'parameters' }];
export const importAdPrices = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.importId === undefined) {
        throw new Error('Missing required parameter: importId');
    }
    const path = '/api/ws-digital/ad-prices/import/{importId}';
    const pathInternal = '/api/ad-prices/import/{importId}';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.file !== undefined) {
        formData.append('file', toCorrectFormDataValue(params.file));
    }
    if (params.importId !== undefined) {
        urlParams.append('importId', params.importId.toString());
    }
    if (params.shouldUpdateExisting !== undefined) {
        urlParams.append('shouldUpdateExisting', params.shouldUpdateExisting.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
importAdPrices.paramsOrder = [{ type: 'formData' }, { type: 'parameters' }];
export const getAdPriceImportTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/ad-prices/import/template';
    const pathInternal = '/api/ad-prices/import/template';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
getAdPriceImportTemplate.paramsOrder = [];
export const getWebsitesByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteIds === undefined) {
        throw new Error('Missing required body: websiteIds');
    }
    const path = '/api/ws-digital/websites-by-ids';
    const pathInternal = '/api/websites-by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.websiteIds !== undefined) {
        body = params.websiteIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getWebsitesByIds.paramsOrder = [{ type: 'body', paramName: 'websiteIds' }];
export const getWebsiteNamesByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteIds === undefined) {
        throw new Error('Missing required body: websiteIds');
    }
    const path = '/api/ws-digital/website-names-by-ids';
    const pathInternal = '/api/website-names-by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.websiteIds !== undefined) {
        body = params.websiteIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getWebsiteNamesByIds.paramsOrder = [{ type: 'body', paramName: 'websiteIds' }];
export const findCampaignPositionByIdAnonymous = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-digital/anonymous/campaign-positions/{campaignPositionId}'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/anonymous/campaign-positions/{campaignPositionId}'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
findCampaignPositionByIdAnonymous.paramsOrder = [{ type: 'parameters' }];
export const findCampaignPositionsByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionIdList === undefined) {
        throw new Error('Missing required body: campaignPositionIdList');
    }
    const path = '/api/ws-digital/campaign-positions/byIds';
    const pathInternal = '/api/campaign-positions/byIds';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionIdList !== undefined) {
        body = params.campaignPositionIdList;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
findCampaignPositionsByIds.paramsOrder = [{ type: 'body', paramName: 'campaignPositionIdList' }];
export const getCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-digital/campaign-positions/get';
    const pathInternal = '/api/campaign-positions/get';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const getCampaignPositionsImpressions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.accountIds === undefined) {
        throw new Error('Missing required body: accountIds');
    }
    const path = '/api/ws-digital/campaign-positions/get/impressions';
    const pathInternal = '/api/campaign-positions/get/impressions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountIds !== undefined) {
        body = params.accountIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionsImpressions.paramsOrder = [{ type: 'body', paramName: 'accountIds' }];
export const getFilteredCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionFilter === undefined) {
        throw new Error('Missing required body: campaignPositionFilter');
    }
    const path = '/api/ws-digital/campaign-positions/filtered';
    const pathInternal = '/api/campaign-positions/filtered';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionFilter !== undefined) {
        body = params.campaignPositionFilter;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getFilteredCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'campaignPositionFilter' }];
export const replaceAccountId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.newAccountId === undefined) {
        throw new Error('Missing required parameter: newAccountId');
    }
    const path = '/api/ws-digital/accounts/replace-account-id';
    const pathInternal = '/api/accounts/replace-account-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.newAccountId !== undefined) {
        urlParams.append('newAccountId', params.newAccountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
replaceAccountId.paramsOrder = [{ type: 'parameters' }];
export const findAllMainWebsites = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/all-main-websites';
    const pathInternal = '/api/all-main-websites';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.includeInactive !== undefined) {
        urlParams.append('includeInactive', params.includeInactive.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
findAllMainWebsites.paramsOrder = [{ type: 'parameters' }];
export const getAllActiveWebsites = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/websites/active';
    const pathInternal = '/api/websites/active';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.ownOrShared !== undefined) {
        urlParams.append('ownOrShared', params.ownOrShared.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllActiveWebsites.paramsOrder = [{ type: 'parameters' }];
export const getAllActiveWebsiteNamesCheckPermission = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/websites/active-check-permission';
    const pathInternal = '/api/websites/active-check-permission';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.ownOrShared !== undefined) {
        urlParams.append('ownOrShared', params.ownOrShared.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllActiveWebsiteNamesCheckPermission.paramsOrder = [{ type: 'parameters' }];
export const getWebsiteStatistic = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/publishers/{websiteId}/statistics'.replace('{websiteId}', params.websiteId?.toString());
    const pathInternal = '/api/publishers/{websiteId}/statistics'.replace('{websiteId}', params.websiteId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.currency !== undefined) {
        urlParams.append('currency', params.currency.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getWebsiteStatistic.paramsOrder = [{ type: 'parameters' }];
export const getPublisherCompanies = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/publishers/companies';
    const pathInternal = '/api/publishers/companies';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.websiteId !== undefined) {
        urlParams.append('websiteId', params.websiteId.toString());
    }
    if (params.type !== undefined) {
        urlParams.append('type', params.type.toString());
    }
    if (params.currency !== undefined) {
        urlParams.append('currency', params.currency.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPublisherCompanies.paramsOrder = [{ type: 'parameters' }];
export const getPublisherActiveCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/publishers/campaign-positions/active';
    const pathInternal = '/api/publishers/campaign-positions/active';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.websiteId !== undefined) {
        urlParams.append('websiteId', params.websiteId.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    if (params.campaignTypeName !== undefined) {
        urlParams.append('campaignTypeName', params.campaignTypeName.toString());
    }
    if (params.currency !== undefined) {
        urlParams.append('currency', params.currency.toString());
    }
    if (params.mediaType !== undefined) {
        urlParams.append('mediaType', params.mediaType.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPublisherActiveCampaignPositions.paramsOrder = [{ type: 'parameters' }];
export const getPublisherPayoutCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/publishers/campaign-positions/payout';
    const pathInternal = '/api/publishers/campaign-positions/payout';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.websiteId !== undefined) {
        urlParams.append('websiteId', params.websiteId.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    if (params.campaignTypeName !== undefined) {
        urlParams.append('campaignTypeName', params.campaignTypeName.toString());
    }
    if (params.currency !== undefined) {
        urlParams.append('currency', params.currency.toString());
    }
    if (params.mediaType !== undefined) {
        urlParams.append('mediaType', params.mediaType.toString());
    }
    if (params.dateFrom !== undefined) {
        urlParams.append('dateFrom', params.dateFrom.toString());
    }
    if (params.dateTo !== undefined) {
        urlParams.append('dateTo', params.dateTo.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPublisherPayoutCampaignPositions.paramsOrder = [{ type: 'parameters' }];
export const getCampaignPositionsWithExcludedWebsites = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    if (params.isPayoutRevenue === undefined) {
        throw new Error('Missing required parameter: isPayoutRevenue');
    }
    const path = '/api/ws-digital/publishers/campaign-positions/excluded-websites';
    const pathInternal = '/api/publishers/campaign-positions/excluded-websites';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.websiteId !== undefined) {
        urlParams.append('websiteId', params.websiteId.toString());
    }
    if (params.isPayoutRevenue !== undefined) {
        urlParams.append('isPayoutRevenue', params.isPayoutRevenue.toString());
    }
    if (params.product !== undefined) {
        urlParams.append('product', params.product.toString());
    }
    if (params.type !== undefined) {
        urlParams.append('type', params.type.toString());
    }
    if (params.currency !== undefined) {
        urlParams.append('currency', params.currency.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionsWithExcludedWebsites.paramsOrder = [{ type: 'parameters' }];
export const addWebsiteExclusionForPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/publishers/campaign-positions/{campaignPositionId}/websites/{websiteId}/exclude-website'
        .replace('{campaignPositionId}', params.campaignPositionId?.toString())
        .replace('{websiteId}', params.websiteId?.toString());
    const pathInternal = '/api/publishers/campaign-positions/{campaignPositionId}/websites/{websiteId}/exclude-website'
        .replace('{campaignPositionId}', params.campaignPositionId?.toString())
        .replace('{websiteId}', params.websiteId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
addWebsiteExclusionForPosition.paramsOrder = [{ type: 'parameters' }];
export const removeWebsiteExclusionForPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/publishers/campaign-positions/{campaignPositionId}/websites/{websiteId}/exclude-website'
        .replace('{campaignPositionId}', params.campaignPositionId?.toString())
        .replace('{websiteId}', params.websiteId?.toString());
    const pathInternal = '/api/publishers/campaign-positions/{campaignPositionId}/websites/{websiteId}/exclude-website'
        .replace('{campaignPositionId}', params.campaignPositionId?.toString())
        .replace('{websiteId}', params.websiteId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
removeWebsiteExclusionForPosition.paramsOrder = [{ type: 'parameters' }];
export const addWebsiteExclusionForCampaignPositionsAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/publishers/campaign-positions/{campaignPositionId}/websites/{websiteId}/exclude-account'
        .replace('{campaignPositionId}', params.campaignPositionId?.toString())
        .replace('{websiteId}', params.websiteId?.toString());
    const pathInternal = '/api/publishers/campaign-positions/{campaignPositionId}/websites/{websiteId}/exclude-account'
        .replace('{campaignPositionId}', params.campaignPositionId?.toString())
        .replace('{websiteId}', params.websiteId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
addWebsiteExclusionForCampaignPositionsAccount.paramsOrder = [{ type: 'parameters' }];
export const removeWebsiteExclusionForCampaignPositionsAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/publishers/campaign-positions/{campaignPositionId}/websites/{websiteId}/exclude-account'
        .replace('{campaignPositionId}', params.campaignPositionId?.toString())
        .replace('{websiteId}', params.websiteId?.toString());
    const pathInternal = '/api/publishers/campaign-positions/{campaignPositionId}/websites/{websiteId}/exclude-account'
        .replace('{campaignPositionId}', params.campaignPositionId?.toString())
        .replace('{websiteId}', params.websiteId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
removeWebsiteExclusionForCampaignPositionsAccount.paramsOrder = [{ type: 'parameters' }];
export const addWebsiteExclusionForAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/publishers/accounts/{accountId}/exclude-website/{websiteId}'
        .replace('{accountId}', params.accountId?.toString())
        .replace('{websiteId}', params.websiteId?.toString());
    const pathInternal = '/api/publishers/accounts/{accountId}/exclude-website/{websiteId}'
        .replace('{accountId}', params.accountId?.toString())
        .replace('{websiteId}', params.websiteId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
addWebsiteExclusionForAccount.paramsOrder = [{ type: 'parameters' }];
export const removeWebsiteExclusionForAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/publishers/accounts/{accountId}/exclude-website/{websiteId}'
        .replace('{accountId}', params.accountId?.toString())
        .replace('{websiteId}', params.websiteId?.toString());
    const pathInternal = '/api/publishers/accounts/{accountId}/exclude-website/{websiteId}'
        .replace('{accountId}', params.accountId?.toString())
        .replace('{websiteId}', params.websiteId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
removeWebsiteExclusionForAccount.paramsOrder = [{ type: 'parameters' }];
export const getPublisherDeliveryDataPerDay = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/publishers/delivery-data-per-day';
    const pathInternal = '/api/publishers/delivery-data-per-day';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionId !== undefined) {
        urlParams.append('campaignPositionId', params.campaignPositionId.toString());
    }
    if (params.websiteId !== undefined) {
        urlParams.append('websiteId', params.websiteId.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPublisherDeliveryDataPerDay.paramsOrder = [{ type: 'parameters' }];
export const getPublisherDeliveryDataPerPublisher = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/publishers/delivery-data-per-publisher';
    const pathInternal = '/api/publishers/delivery-data-per-publisher';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionId !== undefined) {
        urlParams.append('campaignPositionId', params.campaignPositionId.toString());
    }
    if (params.websiteId !== undefined) {
        urlParams.append('websiteId', params.websiteId.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPublisherDeliveryDataPerPublisher.paramsOrder = [{ type: 'parameters' }];
export const getAnonymousAllAdMedium = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/public/admedium';
    const pathInternal = '/api/public/admedium';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAnonymousAllAdMedium.paramsOrder = [{ type: 'parameters' }];
export const getAllAdMedium = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/admedium';
    const pathInternal = '/api/admedium';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.priceListId !== undefined) {
        urlParams.append('priceListId', params.priceListId.toString());
    }
    if (params.adTypeId !== undefined) {
        urlParams.append('adTypeId', params.adTypeId.toString());
    }
    if (params.includeInactive !== undefined) {
        urlParams.append('includeInactive', params.includeInactive.toString());
    }
    if (params.isDefaultBusinessclick !== undefined) {
        urlParams.append('isDefaultBusinessclick', params.isDefaultBusinessclick.toString());
    }
    if (params.positionGroupPrice !== undefined) {
        urlParams.append('positionGroupPrice', params.positionGroupPrice.toString());
    }
    if (params.billingType !== undefined) {
        urlParams.append('billingType', params.billingType.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    if (params.currency !== undefined) {
        urlParams.append('currency', params.currency.toString());
    }
    if (params.adServerType !== undefined) {
        urlParams.append('adServerType', params.adServerType.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllAdMedium.paramsOrder = [{ type: 'parameters' }];
export const createAdMedium = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adMedium === undefined) {
        throw new Error('Missing required body: adMedium');
    }
    const path = '/api/ws-digital/admedium';
    const pathInternal = '/api/admedium';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adMedium !== undefined) {
        body = params.adMedium;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAdMedium.paramsOrder = [{ type: 'body', paramName: 'adMedium' }];
export const getAdMedium = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adMediumId === undefined) {
        throw new Error('Missing required parameter: adMediumId');
    }
    const path = '/api/ws-digital/admedium/{adMediumId}'.replace('{adMediumId}', params.adMediumId?.toString());
    const pathInternal = '/api/admedium/{adMediumId}'.replace('{adMediumId}', params.adMediumId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdMedium.paramsOrder = [{ type: 'parameters' }];
export const updateAdMedium = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adMedium === undefined) {
        throw new Error('Missing required body: adMedium');
    }
    if (params.adMediumId === undefined) {
        throw new Error('Missing required parameter: adMediumId');
    }
    const path = '/api/ws-digital/admedium/{adMediumId}'.replace('{adMediumId}', params.adMediumId?.toString());
    const pathInternal = '/api/admedium/{adMediumId}'.replace('{adMediumId}', params.adMediumId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adMedium !== undefined) {
        body = params.adMedium;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdMedium.paramsOrder = [{ type: 'body', paramName: 'adMedium' }, { type: 'parameters' }];
export const getAdPlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/adplacements/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/adplacements/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdPlacement.paramsOrder = [{ type: 'parameters' }];
export const updateAdPlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adPlacement === undefined) {
        throw new Error('Missing required body: adPlacement');
    }
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/adplacements/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/adplacements/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adPlacement !== undefined) {
        body = params.adPlacement;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdPlacement.paramsOrder = [{ type: 'body', paramName: 'adPlacement' }, { type: 'parameters' }];
export const getAnonymousAllAdPlacements = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/public/adplacements';
    const pathInternal = '/api/public/adplacements';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.adMediumId !== undefined) {
        urlParams.append('adMediumId', params.adMediumId.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAnonymousAllAdPlacements.paramsOrder = [{ type: 'parameters' }];
export const getAllAdPlacements = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/adplacements';
    const pathInternal = '/api/adplacements';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.adMediumId !== undefined) {
        urlParams.append('adMediumId', params.adMediumId.toString());
    }
    if (params.adTypeId !== undefined) {
        urlParams.append('adTypeId', params.adTypeId.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.priceListId !== undefined) {
        urlParams.append('priceListId', params.priceListId.toString());
    }
    if (params.includeInactive !== undefined) {
        urlParams.append('includeInactive', params.includeInactive.toString());
    }
    if (params.positionGroupPrice !== undefined) {
        urlParams.append('positionGroupPrice', params.positionGroupPrice.toString());
    }
    if (params.billingType !== undefined) {
        urlParams.append('billingType', params.billingType.toString());
    }
    if (params.languageType !== undefined) {
        urlParams.append('languageType', params.languageType.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    if (params.adServerType !== undefined) {
        urlParams.append('adServerType', params.adServerType.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllAdPlacements.paramsOrder = [{ type: 'parameters' }];
export const createAdPlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adPlacement === undefined) {
        throw new Error('Missing required body: adPlacement');
    }
    const path = '/api/ws-digital/adplacements';
    const pathInternal = '/api/adplacements';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adPlacement !== undefined) {
        body = params.adPlacement;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAdPlacement.paramsOrder = [{ type: 'body', paramName: 'adPlacement' }];
export const getBatchPlacements = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.lastModified === undefined) {
        throw new Error('Missing required parameter: lastModified');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-digital/batch/placements';
    const pathInternal = '/api/batch/placements';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.lastModified !== undefined) {
        urlParams.append('lastModified', params.lastModified.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchPlacements.paramsOrder = [{ type: 'parameters' }];
export const getAllCompaniesPaginatedAdTypes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/adtypes/all-companies';
    const pathInternal = '/api/adtypes/all-companies';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.adPlacementId !== undefined) {
        urlParams.append('adPlacementId', params.adPlacementId.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.includeInactive !== undefined) {
        urlParams.append('includeInactive', params.includeInactive.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllCompaniesPaginatedAdTypes.paramsOrder = [{ type: 'parameters' }];
export const getPaginatedAdTypes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/adtypes';
    const pathInternal = '/api/adtypes';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.adPlacementId !== undefined) {
        urlParams.append('adPlacementId', params.adPlacementId.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.includeInactive !== undefined) {
        urlParams.append('includeInactive', params.includeInactive.toString());
    }
    if (params.currency !== undefined) {
        urlParams.append('currency', params.currency.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPaginatedAdTypes.paramsOrder = [{ type: 'parameters' }];
export const createAdType = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adType === undefined) {
        throw new Error('Missing required body: adType');
    }
    const path = '/api/ws-digital/adtypes';
    const pathInternal = '/api/adtypes';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adType !== undefined) {
        body = params.adType;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAdType.paramsOrder = [{ type: 'body', paramName: 'adType' }];
export const getAdType = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/adtypes/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/adtypes/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdType.paramsOrder = [{ type: 'parameters' }];
export const updateAdType = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adType === undefined) {
        throw new Error('Missing required body: adType');
    }
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/adtypes/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/adtypes/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adType !== undefined) {
        body = params.adType;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdType.paramsOrder = [{ type: 'body', paramName: 'adType' }, { type: 'parameters' }];
export const getAdTypeByNameAndCompanyId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.name === undefined) {
        throw new Error('Missing required parameter: name');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-digital/adtypes/by-name';
    const pathInternal = '/api/adtypes/by-name';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.name !== undefined) {
        urlParams.append('name', params.name.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdTypeByNameAndCompanyId.paramsOrder = [{ type: 'parameters' }];
export const getBatchAdTypes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.period === undefined) {
        throw new Error('Missing required parameter: period');
    }
    const path = '/api/ws-digital/ad-types/batch';
    const pathInternal = '/api/ad-types/batch';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchAdTypes.paramsOrder = [{ type: 'parameters' }];
export const getAllAdMediumMappings = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/admedium/mappings';
    const pathInternal = '/api/admedium/mappings';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllAdMediumMappings.paramsOrder = [];
export const createAdMediumMapping = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.name === undefined) {
        throw new Error('Missing required parameter: name');
    }
    const path = '/api/ws-digital/admedium/mappings';
    const pathInternal = '/api/admedium/mappings';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.name !== undefined) {
        urlParams.append('name', params.name.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAdMediumMapping.paramsOrder = [{ type: 'parameters' }];
export const saveAdMediumMapping = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adMediumId === undefined) {
        throw new Error('Missing required parameter: adMediumId');
    }
    const path = '/api/ws-digital/admedium/{adMediumId}/mapping'.replace('{adMediumId}', params.adMediumId?.toString());
    const pathInternal = '/api/admedium/{adMediumId}/mapping'.replace('{adMediumId}', params.adMediumId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.mappingId !== undefined) {
        urlParams.append('mappingId', params.mappingId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
saveAdMediumMapping.paramsOrder = [{ type: 'parameters' }];
export const resetAdMediumMapping = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adMediumId === undefined) {
        throw new Error('Missing required parameter: adMediumId');
    }
    const path = '/api/ws-digital/admedium/{adMediumId}/mapping'.replace('{adMediumId}', params.adMediumId?.toString());
    const pathInternal = '/api/admedium/{adMediumId}/mapping'.replace('{adMediumId}', params.adMediumId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
resetAdMediumMapping.paramsOrder = [{ type: 'parameters' }];
export const deleteAdMediumMapping = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/admedium/mappings/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/admedium/mappings/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
deleteAdMediumMapping.paramsOrder = [{ type: 'parameters' }];
export const editAdMediumMapping = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.name === undefined) {
        throw new Error('Missing required parameter: name');
    }
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/admedium/mappings/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/admedium/mappings/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.name !== undefined) {
        urlParams.append('name', params.name.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
editAdMediumMapping.paramsOrder = [{ type: 'parameters' }];
export const getCampaignPositionsAdMediums = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    if (params.filterType === undefined) {
        throw new Error('Missing required parameter: filterType');
    }
    const path = '/api/ws-digital/campaign-positions/adMediums';
    const pathInternal = '/api/campaign-positions/adMediums';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.websiteId !== undefined) {
        urlParams.append('websiteId', params.websiteId.toString());
    }
    if (params.filterType !== undefined) {
        urlParams.append('filterType', params.filterType.toString());
    }
    if (params.type !== undefined) {
        urlParams.append('type', params.type.toString());
    }
    if (params.currency !== undefined) {
        urlParams.append('currency', params.currency.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionsAdMediums.paramsOrder = [{ type: 'parameters' }];
export const getCampaignPositionsTypes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/campaign-positions/types';
    const pathInternal = '/api/campaign-positions/types';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionsTypes.paramsOrder = [];
export const getPublisherCampaignTypeNames = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/campaign-positions/campaign-type-names';
    const pathInternal = '/api/campaign-positions/campaign-type-names';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPublisherCampaignTypeNames.paramsOrder = [];
export const getMonthlyRevenue = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/revenue-stats/monthly';
    const pathInternal = '/api/revenue-stats/monthly';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.websiteId !== undefined) {
        urlParams.append('websiteId', params.websiteId.toString());
    }
    if (params.currency !== undefined) {
        urlParams.append('currency', params.currency.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getMonthlyRevenue.paramsOrder = [{ type: 'parameters' }];
export const getMonthlyPayoutRevenue = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/revenue-stats/monthly-payout';
    const pathInternal = '/api/revenue-stats/monthly-payout';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.websiteId !== undefined) {
        urlParams.append('websiteId', params.websiteId.toString());
    }
    if (params.currency !== undefined) {
        urlParams.append('currency', params.currency.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getMonthlyPayoutRevenue.paramsOrder = [{ type: 'parameters' }];
export const getRevenueByIndustry = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/revenue-stats/by-industry';
    const pathInternal = '/api/revenue-stats/by-industry';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.websiteId !== undefined) {
        urlParams.append('websiteId', params.websiteId.toString());
    }
    if (params.currency !== undefined) {
        urlParams.append('currency', params.currency.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getRevenueByIndustry.paramsOrder = [{ type: 'parameters' }];
export const getDailyRevenues = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    if (params.numberOfDays === undefined) {
        throw new Error('Missing required parameter: numberOfDays');
    }
    const path = '/api/ws-digital/revenue-stats/daily';
    const pathInternal = '/api/revenue-stats/daily';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.websiteId !== undefined) {
        urlParams.append('websiteId', params.websiteId.toString());
    }
    if (params.numberOfDays !== undefined) {
        urlParams.append('numberOfDays', params.numberOfDays.toString());
    }
    if (params.currency !== undefined) {
        urlParams.append('currency', params.currency.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDailyRevenues.paramsOrder = [{ type: 'parameters' }];
export const getRevenueByAdType = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    if (params.adType === undefined) {
        throw new Error('Missing required parameter: adType');
    }
    const path = '/api/ws-digital/revenue-stats/ad-type';
    const pathInternal = '/api/revenue-stats/ad-type';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.websiteId !== undefined) {
        urlParams.append('websiteId', params.websiteId.toString());
    }
    if (params.adType !== undefined) {
        urlParams.append('adType', params.adType.toString());
    }
    if (params.currency !== undefined) {
        urlParams.append('currency', params.currency.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getRevenueByAdType.paramsOrder = [{ type: 'parameters' }];
export const getForecastForAdPrice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adPriceId === undefined) {
        throw new Error('Missing required parameter: adPriceId');
    }
    const path = '/api/ws-digital/forecast/ad-prices/{adPriceId}'.replace('{adPriceId}', params.adPriceId?.toString());
    const pathInternal = '/api/forecast/ad-prices/{adPriceId}'.replace('{adPriceId}', params.adPriceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forecastRequest !== undefined) {
        body = params.forecastRequest;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getForecastForAdPrice.paramsOrder = [{ type: 'body', paramName: 'forecastRequest' }, { type: 'parameters' }];
export const getForecastContentions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adPriceId === undefined) {
        throw new Error('Missing required parameter: adPriceId');
    }
    const path = '/api/ws-digital/forecast-contentions/ad-prices/{adPriceId}'.replace('{adPriceId}', params.adPriceId?.toString());
    const pathInternal = '/api/forecast-contentions/ad-prices/{adPriceId}'.replace('{adPriceId}', params.adPriceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forecastRequest !== undefined) {
        body = params.forecastRequest;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getForecastContentions.paramsOrder = [{ type: 'body', paramName: 'forecastRequest' }, { type: 'parameters' }];
export const getForecastForCampaignPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adPriceId === undefined) {
        throw new Error('Missing required parameter: adPriceId');
    }
    const path = '/api/ws-digital/forecast/campaign-positions/ad-prices/{adPriceId}'.replace('{adPriceId}', params.adPriceId?.toString());
    const pathInternal = '/api/forecast/campaign-positions/ad-prices/{adPriceId}'.replace('{adPriceId}', params.adPriceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forecastForm !== undefined) {
        body = params.forecastForm;
    }
    if (params.campaignPositionId !== undefined) {
        urlParams.append('campaignPositionId', params.campaignPositionId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getForecastForCampaignPosition.paramsOrder = [
    { type: 'body', paramName: 'forecastForm' },
    { type: 'parameters' },
];
export const getWebsiteTargetings = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adPriceId === undefined) {
        throw new Error('Missing required parameter: adPriceId');
    }
    const path = '/api/ws-digital/ad-prices/{adPriceId}/website-targetings'.replace('{adPriceId}', params.adPriceId?.toString());
    const pathInternal = '/api/ad-prices/{adPriceId}/website-targetings'.replace('{adPriceId}', params.adPriceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getWebsiteTargetings.paramsOrder = [{ type: 'parameters' }];
export const getPaginatedAdSpecs = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/adspecs';
    const pathInternal = '/api/adspecs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.adMediumId !== undefined) {
        urlParams.append('adMediumId', params.adMediumId.toString());
    }
    if (params.adPlacementId !== undefined) {
        urlParams.append('adPlacementId', params.adPlacementId.toString());
    }
    if (params.adTypeId !== undefined) {
        urlParams.append('adTypeId', params.adTypeId.toString());
    }
    if (params.priceListId !== undefined) {
        urlParams.append('priceListId', params.priceListId.toString());
    }
    if (params.billingType !== undefined) {
        urlParams.append('billingType', params.billingType.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    if (params.includeInactive !== undefined) {
        urlParams.append('includeInactive', params.includeInactive.toString());
    }
    if (params.adServerType !== undefined) {
        urlParams.append('adServerType', params.adServerType.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPaginatedAdSpecs.paramsOrder = [{ type: 'parameters' }];
export const createAdSpec = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adSpec === undefined) {
        throw new Error('Missing required body: adSpec');
    }
    const path = '/api/ws-digital/adspecs';
    const pathInternal = '/api/adspecs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adSpec !== undefined) {
        body = params.adSpec;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAdSpec.paramsOrder = [{ type: 'body', paramName: 'adSpec' }];
export const getBatchAdSpecs = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.lastModified === undefined) {
        throw new Error('Missing required parameter: lastModified');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-digital/batch/ad-specs';
    const pathInternal = '/api/batch/ad-specs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.lastModified !== undefined) {
        urlParams.append('lastModified', params.lastModified.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchAdSpecs.paramsOrder = [{ type: 'parameters' }];
export const adSpecExistsByLabelId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.labelId === undefined) {
        throw new Error('Missing required parameter: labelId');
    }
    const path = '/api/ws-digital/adspecs/exists-by-label-id';
    const pathInternal = '/api/adspecs/exists-by-label-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.labelId !== undefined) {
        urlParams.append('labelId', params.labelId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
adSpecExistsByLabelId.paramsOrder = [{ type: 'parameters' }];
export const getAnonymousPaginatedAdPrices = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/public/adprices';
    const pathInternal = '/api/public/adprices';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.adMediumId !== undefined) {
        urlParams.append('adMediumId', params.adMediumId.toString());
    }
    if (params.adPlacementId !== undefined) {
        urlParams.append('adPlacementId', params.adPlacementId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAnonymousPaginatedAdPrices.paramsOrder = [{ type: 'parameters' }];
export const getPaginatedAdPrices = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/adprices';
    const pathInternal = '/api/adprices';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.adMediumId !== undefined) {
        urlParams.append('adMediumId', params.adMediumId.toString());
    }
    if (params.adPlacementId !== undefined) {
        urlParams.append('adPlacementId', params.adPlacementId.toString());
    }
    if (params.adTypeId !== undefined) {
        urlParams.append('adTypeId', params.adTypeId.toString());
    }
    if (params.priceListId !== undefined) {
        urlParams.append('priceListId', params.priceListId.toString());
    }
    if (params.includeInactive !== undefined) {
        urlParams.append('includeInactive', params.includeInactive.toString());
    }
    if (params.billingType !== undefined) {
        urlParams.append('billingType', params.billingType.toString());
    }
    if (params.onlyDefaultBusinessclick !== undefined) {
        urlParams.append('onlyDefaultBusinessclick', params.onlyDefaultBusinessclick.toString());
    }
    if (params.positionGroupPrice !== undefined) {
        urlParams.append('positionGroupPrice', params.positionGroupPrice.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    if (params.currency !== undefined) {
        urlParams.append('currency', params.currency.toString());
    }
    if (params.adServerType !== undefined) {
        urlParams.append('adServerType', params.adServerType.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPaginatedAdPrices.paramsOrder = [{ type: 'parameters' }];
export const createAdPrice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adPrice === undefined) {
        throw new Error('Missing required body: adPrice');
    }
    const path = '/api/ws-digital/adprices';
    const pathInternal = '/api/adprices';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adPrice !== undefined) {
        body = params.adPrice;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAdPrice.paramsOrder = [{ type: 'body', paramName: 'adPrice' }];
export const getBatchAdPrices = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-digital/batch/ad-prices';
    const pathInternal = '/api/batch/ad-prices';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.lastModified !== undefined) {
        urlParams.append('lastModified', params.lastModified.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchAdPrices.paramsOrder = [{ type: 'parameters' }];
export const getAdPrice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/adprices/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/adprices/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdPrice.paramsOrder = [{ type: 'parameters' }];
export const updateAdPrice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.adSpec === undefined) {
        throw new Error('Missing required body: adSpec');
    }
    const path = '/api/ws-digital/adprices/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/adprices/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adSpec !== undefined) {
        body = params.adSpec;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdPrice.paramsOrder = [{ type: 'body', paramName: 'adSpec' }, { type: 'parameters' }];
export const getAdPricesByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adPriceIds === undefined) {
        throw new Error('Missing required body: adPriceIds');
    }
    const path = '/api/ws-digital/adprices/by-ids';
    const pathInternal = '/api/adprices/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adPriceIds !== undefined) {
        body = params.adPriceIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdPricesByIds.paramsOrder = [{ type: 'body', paramName: 'adPriceIds' }];
export const checkForAdPriceCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/adprices/{id}/check-for-positions'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/adprices/{id}/check-for-positions'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
checkForAdPriceCampaignPositions.paramsOrder = [{ type: 'parameters' }];
export const downloadPublisherCampaignsReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-digital/campaigns/download';
    const pathInternal = '/api/campaigns/download';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.websiteId !== undefined) {
        urlParams.append('websiteId', params.websiteId.toString());
    }
    if (params.adMedium !== undefined) {
        urlParams.append('adMedium', params.adMedium.toString());
    }
    if (params.type !== undefined) {
        urlParams.append('type', params.type.toString());
    }
    if (params.currency !== undefined) {
        urlParams.append('currency', params.currency.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
downloadPublisherCampaignsReport.paramsOrder = [{ type: 'parameters' }];
export const getFrequencyCappingPeriods = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.adServerType === undefined) {
        throw new Error('Missing required parameter: adServerType');
    }
    const path = '/api/ws-digital/campaign-positions/capping-periods/{adServerType}'.replace('{adServerType}', params.adServerType?.toString());
    const pathInternal = '/api/campaign-positions/capping-periods/{adServerType}'.replace('{adServerType}', params.adServerType?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getFrequencyCappingPeriods.paramsOrder = [{ type: 'parameters' }];
export const getAcceptedYearList = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/payout/years';
    const pathInternal = '/api/payout/years';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAcceptedYearList.paramsOrder = [];
export const generateAllReports = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.date === undefined) {
        throw new Error('Missing required parameter: date');
    }
    const path = '/api/ws-digital/payout/{date}/generate-all-reports'.replace('{date}', params.date?.toString());
    const pathInternal = '/api/payout/{date}/generate-all-reports'.replace('{date}', params.date?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
generateAllReports.paramsOrder = [{ type: 'parameters' }];
export const getCampaignDeliveryDataPerDay = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-digital/campaign-delivery-data-per-day';
    const pathInternal = '/api/campaign-delivery-data-per-day';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignDeliveryDataPerDay.paramsOrder = [{ type: 'parameters' }];
export const getDeliveryDataPerDay = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-digital/delivery-data-per-day';
    const pathInternal = '/api/delivery-data-per-day';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionId !== undefined) {
        urlParams.append('campaignPositionId', params.campaignPositionId.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDeliveryDataPerDay.paramsOrder = [{ type: 'parameters' }];
export const getDeliveryDataPerPublisher = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-digital/delivery-data-per-publisher';
    const pathInternal = '/api/delivery-data-per-publisher';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionId !== undefined) {
        urlParams.append('campaignPositionId', params.campaignPositionId.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDeliveryDataPerPublisher.paramsOrder = [{ type: 'parameters' }];
export const getDeliveryDataPerCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-digital/delivery-data-per-creative';
    const pathInternal = '/api/delivery-data-per-creative';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionId !== undefined) {
        urlParams.append('campaignPositionId', params.campaignPositionId.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDeliveryDataPerCreative.paramsOrder = [{ type: 'parameters' }];
export const getLineItemCompanies = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/company-per-line-item';
    const pathInternal = '/api/company-per-line-item';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getLineItemCompanies.paramsOrder = [{ type: 'parameters' }];
export const getCompanyXandrLineItems = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/company/xandr/line-items';
    const pathInternal = '/api/company/xandr/line-items';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyXandrLineItems.paramsOrder = [{ type: 'parameters' }];
export const enrichEventWithCompanyId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/enrich';
    const pathInternal = '/api/enrich';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.eventBody !== undefined) {
        body = params.eventBody;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
enrichEventWithCompanyId.paramsOrder = [{ type: 'body', paramName: 'eventBody' }];
export const importDeliveryData = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.importId === undefined) {
        throw new Error('Missing required parameter: importId');
    }
    const path = '/api/ws-digital/import/delivery-data';
    const pathInternal = '/api/import/delivery-data';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.file !== undefined) {
        formData.append('file', toCorrectFormDataValue(params.file));
    }
    if (params.importId !== undefined) {
        urlParams.append('importId', params.importId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
importDeliveryData.paramsOrder = [{ type: 'formData' }, { type: 'parameters' }];
export const getDeliveryDataImportTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/import/delivery-data/template';
    const pathInternal = '/api/import/delivery-data/template';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
getDeliveryDataImportTemplate.paramsOrder = [];
export const getAllCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    if (params.fromDate === undefined) {
        throw new Error('Missing required parameter: fromDate');
    }
    if (params.toDate === undefined) {
        throw new Error('Missing required parameter: toDate');
    }
    const path = '/api/ws-digital/campaign-positions/all';
    const pathInternal = '/api/campaign-positions/all';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.websiteId !== undefined) {
        urlParams.append('websiteId', params.websiteId.toString());
    }
    if (params.product !== undefined) {
        urlParams.append('product', params.product.toString());
    }
    if (params.fromDate !== undefined) {
        urlParams.append('fromDate', params.fromDate.toString());
    }
    if (params.toDate !== undefined) {
        urlParams.append('toDate', params.toDate.toString());
    }
    if (params.type !== undefined) {
        urlParams.append('type', params.type.toString());
    }
    if (params.currency !== undefined) {
        urlParams.append('currency', params.currency.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllCampaignPositions.paramsOrder = [{ type: 'parameters' }];
export const getPriceLists = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/price-lists';
    const pathInternal = '/api/price-lists';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.includeInactivePriceLists !== undefined) {
        urlParams.append('includeInactivePriceLists', params.includeInactivePriceLists.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    if (params.includeInactivePrices !== undefined) {
        urlParams.append('includeInactivePrices', params.includeInactivePrices.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPriceLists.paramsOrder = [{ type: 'parameters' }];
export const getCampaignPositionsByContextualKey = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.keyId === undefined) {
        throw new Error('Missing required parameter: keyId');
    }
    const path = '/api/ws-digital/campaign-positions/contextual-keywords/{keyId}'.replace('{keyId}', params.keyId?.toString());
    const pathInternal = '/api/campaign-positions/contextual-keywords/{keyId}'.replace('{keyId}', params.keyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionsByContextualKey.paramsOrder = [{ type: 'parameters' }];
export const getConversionTrackers = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-digital/conversion-trackers';
    const pathInternal = '/api/conversion-trackers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    if (params.includeInactive !== undefined) {
        urlParams.append('includeInactive', params.includeInactive.toString());
    }
    if (params.searchQuery !== undefined) {
        urlParams.append('searchQuery', params.searchQuery.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getConversionTrackers.paramsOrder = [{ type: 'parameters' }];
export const createConversionTracker = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-digital/conversion-trackers';
    const pathInternal = '/api/conversion-trackers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createConversionTracker.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const getConversionTrackerById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/conversion-trackers/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/conversion-trackers/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getConversionTrackerById.paramsOrder = [{ type: 'parameters' }];
export const updateConversionTracker = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-digital/conversion-trackers/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/conversion-trackers/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateConversionTracker.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const getConversionTrackersByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.trackersIds === undefined) {
        throw new Error('Missing required body: trackersIds');
    }
    const path = '/api/ws-digital/conversion-trackers/by-ids';
    const pathInternal = '/api/conversion-trackers/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.trackersIds !== undefined) {
        body = params.trackersIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getConversionTrackersByIds.paramsOrder = [{ type: 'body', paramName: 'trackersIds' }];
export const downloadConversionTrackerInstruction = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-digital/conversion-trackers/{id}/instruction'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/conversion-trackers/{id}/instruction'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'text/plain';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
downloadConversionTrackerInstruction.paramsOrder = [{ type: 'parameters' }];
export * from './types';
export * from './constants';
